import { render, staticRenderFns } from "./SubprojectoForm.vue?vue&type=template&id=4fa5cb86&scoped=true&lang=pug&"
import script from "./SubprojectoForm.vue?vue&type=script&lang=js&"
export * from "./SubprojectoForm.vue?vue&type=script&lang=js&"
import style0 from "./SubprojectoForm.vue?vue&type=style&index=0&id=4fa5cb86&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa5cb86",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/data/jenkins/workspace/asuparticipa_mapaasu_master-EEJDLXD2Q2AH3UKHZ3KLQPDLCS2LEPGUHAV53OMBNNN5YUGCSZCQ/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
installComponents(component, {VBtn})
